<div class="grid-2col_minMax gap">
  <div class="flex-column gap p-1">
    <!-- Basic Info Section -->
    <app-user-basic-info
      [user]="user"
      [form]="form"
      [passwordForm]="passwordForm"
      [canEdit]="canEditUser()"
      (avatarUpload)="onAvatarUpload($event)">
    </app-user-basic-info>

    <!-- User contact info section -->
    @if (user) {
      <app-user-contact-info-card
        [user]="user"
        [form]="form"
        [canEdit]="canEditUser()">
      </app-user-contact-info-card>
    }

    <!-- Personal Info Section -->
    @if (user) {
      <app-user-personal-info
        [user]="user"
        [form]="form"
        [canEdit]="canEditUser()">
      </app-user-personal-info>
    }

    <!-- User experience section -->
    @if (user) {
      <app-user-experience-table
        [user]="user"
        [canEdit]="canEditUser()">
      </app-user-experience-table>
    }

    <!-- Roles and Rules Section -->
    @if (isAllowed['rule.read']() && canEditUser()) {
      <app-user-role
        #userRules
      ></app-user-role>
    }
  </div>

  <div class="flex-column gap p-1">
    <!-- Employments Section -->
    @if (user) {
      <app-user-employments
        [userId]="user.id"
        [canEdit]="canEditUser()">
      </app-user-employments>
    }

    <!-- Employments Info Section -->
    @if (user) {
      <app-user-employment-info
        [userId]="user.id">
      </app-user-employment-info>
    }

    <div class="add-employment-card">
      <app-user-workplace-table
        [userId]="user?.id || ''"
        [canEdit]="canEditUser()"
        >
      </app-user-workplace-table>
    </div>

    <app-action-buttons
      secondaryButtonType="return"
      [primaryButtonVisibility]="canEditUser()"
      (primaryClickEvent)="save()"
      (secondaryClickEvent)="goToUsers()"
      >
      @if (isAllowed['user.delete']() && canEditUser()) {
        <app-delete-button
          (clickEvent)="delete()">
        </app-delete-button>
      }
    </app-action-buttons>
  </div>
</div>
